import "./style.css";
import Header from "../../../componente/header";
import { useState, useEffect } from "react";
import Modal from "react-modal";
import api from "../../../services/api";

function LancDespesa() {
  const { DateTime } = require("luxon");

  const dt = new Date();
  const dt11 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");
    let time =
      dt.getHours().toString().padStart(2, "0") +
      ":" +
      dt.getMinutes().toString().padStart(2, "0");
    let dtcadastro = dt11 +" "+ time

  const date1 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const date2 =
  dt.getFullYear() +
  "-" +
  (dt.getMonth() + 1).toString().padStart(2, "0") +
  "-" +
  dt.getDate().toString().padStart(2, "0");

  const [abusca, setabusca] = useState("");

  const [tipo, settipo] = useState("L");

  const [dt1, setdt1] = useState(date1);
  const [dt2, setdt2] = useState(date2);

  const [listadespesa, setlistadespesa] = useState([]);
  const [listafornecedor, setlistafornecedor] = useState([]);
  const [listaconta, setlistaconta] = useState([]);
  const [listabanco, setlistabanco] = useState([]);
  const [listamoeda, setlistamoeda] = useState([]);

  const [showform, setshowform] = useState(false);

  const [codcontaspagar, setcodcontaspagar] = useState(0);
  const [parcela, setparcela] = useState(0);
  const [dtvencimento, setdtvencimento] = useState("");
  const [vloriginal, setvloriginal] = useState(0);
  const [vldesconto, setvldesconto] = useState(0);
  const [vlacrescimo, setvlacrescimo] = useState(0);
  const [vlliquido, setvlliquido] = useState(0);
  const [historico, sethistorico] = useState("");
  const [codfornecedor, setcodfornecedor] = useState(0);
  const [codmoeda, setcodmoeda] = useState(0);
  const [codconta, setcodconta] = useState(0);
  const [codbanco, setcodbanco] = useState(0);

  useEffect(() => {
    function ListarDespesa() {
      api
        .get("v1/operacoes/listadespesa", {
          params: {
            busca: abusca,
            tipo,
            dt1,
            dt2,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistadespesa(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarDespesa();
  }, [showform, abusca, tipo, dt1, dt2]);

  useEffect(() => {
    function ListarFornecedor() {
      api
        .get("v1/cadastro/fornecedor", {
          params: {
            busca: "",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistafornecedor(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarFornecedor();
  }, [showform]);

  useEffect(() => {
    function ListarConta() {
      api
        .get("v1/cadastro/conta", {
          params: {
            busca: "",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistaconta(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarConta();
  }, [showform]);

  useEffect(() => {
    function ListarBanco() {
      api
        .get("v1/cadastro/banco", {
          params: {
            busca: "",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistabanco(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarBanco();
  }, [showform]);

  useEffect(() => {
    function ListarMoeda() {
      api
        .get("v1/cadastro/moeda", {
          params: {
            busca: "",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistamoeda(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarMoeda();
  }, [showform]);

  function Cadastrar() {
    api
      .post(
        "v1/operacoes/lancdespesa",
        {
          parcela,
          dtlancamento: dtcadastro,
          dtvencimento,
          vloriginal,
          vldesconto,
          vlacrescimo,
          vlliquido,
          historico,
          excluido: "N",
          codempresa: localStorage.getItem("tempCodEmpresa"),
          codusuario: localStorage.getItem("tempCodUsuario"),
          codfornecedor,
          codmoeda,
          codbanco,
          codconta,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setshowform(false);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function closeModal() {
    setshowform(false);
  }

  function Salvar() {
    if (codfornecedor === 0) {
      alert("Informe o Cliente");
    } else if (codbanco === 0) {
      alert("Informe o Banco/Caixa");
    } else if (codconta === 0) {
      alert("Informe a Categoria");
    } else if (codmoeda === 0) {
      alert("Informe a Condição de Pagamento");
    } else if (parcela <= 0) {
      alert("Informe a Parcela igual ou maior que 1");
    } else if (vlliquido <= 0) {
      alert("Informe o Valor Original");
    } else {
      Cadastrar();
    }
  }

  function Novo() {
    setcodcontaspagar(0);
    setparcela(1);
    setdtvencimento(dt11);
    setvloriginal(0);
    setvldesconto(0);
    setvlacrescimo(0);
    setvlliquido(0);
    sethistorico("");
    setcodfornecedor(0);
    setcodmoeda(0);
    setcodconta(0);
    setcodbanco(0);

    setshowform(true);
  }

  function Calcular(vlorig, vldesc, vlacre) {
    setvloriginal(vlorig);
    setvldesconto(vldesc);
    setvlacrescimo(vlacre);
    setvlliquido(vlorig - vldesc + vlacre);
  }

  function FormataData(props) {
    return props
      ? DateTime.fromISO(props).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : null;
  }

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
          .plus({ hours: 3 })
          .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  return (
    <>
      <Header />

      <div>
        <Modal
          isOpen={showform}
          onRequestClose={closeModal}
          overlayClassName="modal-overlay"
          className="modal-content modal-xl"
        >
          <div className="container-fluid h-100">
            <div className="row">
              <h2>Novo Lançamento</h2>
            </div>
            <div className="row">
              <hr />
            </div>

            <div className="row">
              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <label htmlFor="fornecedor" className="form-label">
                      Localize o Fornecedor
                    </label>
                    <select
                      id="fornecedor"
                      className="form-select"
                      value={codfornecedor}
                      onChange={(e) => setcodfornecedor(e.target.value)}
                    >
                      <option value="0">Escolha o fornecedor</option>
                      {listafornecedor.map(function (forn) {
                        return (
                          <option key={forn.codfornecedor} value={forn.codfornecedor}>
                            {forn.razaonome} - {forn.documento} - {forn.proprietario}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4">
                    <label htmlFor="conta" className="form-label">
                      Localize a Categoria
                    </label>
                    <select
                      id="conta"
                      className="form-select"
                      value={codconta}
                      onChange={(e) => setcodconta(e.target.value)}
                    >
                      <option value="0">Escolha a categoria</option>
                      {listaconta.map(function (con) {
                        return (
                          <option key={con.codconta} value={con.codconta}>
                            {con.conta}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-sm-4">
                    <label htmlFor="banco" className="form-label">
                      Localize o Banco/Caixa
                    </label>
                    <select
                      id="banco"
                      className="form-select"
                      value={codbanco}
                      onChange={(e) => setcodbanco(e.target.value)}
                    >
                      <option value="0">Escolha o banco/caixa</option>
                      {listabanco.map(function (ban) {
                        return (
                          <option key={ban.codbanco} value={ban.codbanco}>
                            {ban.banco}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-sm-4">
                    <label htmlFor="moeda" className="form-label">
                      Localize a Condição de Pagamento
                    </label>
                    <select
                      id="moeda"
                      className="form-select"
                      value={codmoeda}
                      onChange={(e) => setcodmoeda(e.target.value)}
                    >
                      <option value="0">Escolha a condição de pagamento</option>
                      {listamoeda.map(function (moe) {
                        return (
                          <option key={moe.codmoeda} value={moe.codmoeda}>
                            {moe.moeda}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <label htmlFor="historico" className="form-label">
                      Histórico
                    </label>
                    <textarea
                      rows={3}
                      wrap="true"
                      id="historico"
                      className="form-control"
                      placeholder="Informe o histórico"
                      value={historico}
                      onChange={(e) => sethistorico(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-3">
                    <label htmlFor="vloriginal" className="form-label">
                      Vl. Original
                    </label>
                    <input
                      type="number"
                      id="vloriginal"
                      className="form-control"
                      value={vloriginal}
                      onChange={(e) =>
                        Calcular(
                          e.target.valueAsNumber,
                          vldesconto,
                          vlacrescimo
                        )
                      }
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="vldesconto" className="form-label">
                      Vl. Desconto (-)
                    </label>
                    <input
                      type="number"
                      id="vldesconto"
                      className="form-control"
                      value={vldesconto}
                      onChange={(e) =>
                        Calcular(
                          vloriginal,
                          e.target.valueAsNumber,
                          vlacrescimo
                        )
                      }
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="vlacrescimo" className="form-label">
                      Vl. Acrescimo (+)
                    </label>
                    <input
                      type="number"
                      id="vlacrescimo"
                      className="form-control"
                      value={vlacrescimo}
                      onChange={(e) =>
                        Calcular(vloriginal, vldesconto, e.target.valueAsNumber)
                      }
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="vlliquido" className="form-label">
                      Vl. Líquido (=)
                    </label>
                    <input
                      type="number"
                      id="vlliquido"
                      className="form-control"
                      value={vlliquido}
                      disabled
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-3">
                    <label htmlFor="parcela" className="form-label">
                      Qtde Parcelas
                    </label>
                    <input
                      type="number"
                      id="parcela"
                      className="form-control"
                      value={parcela}
                      onChange={(e) => setparcela(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="dtvencimento" className="form-label">
                      Dt. Vencimento
                    </label>
                    <input
                      type="date"
                      id="dtvencimento"
                      className="form-control"
                      value={dtvencimento}
                      onChange={(e) => setdtvencimento(e.target.value)}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button className="btn btn-danger ms-4" onClick={closeModal}>
                  Cancelar
                </button>
                <button className="btn btn-success ms-4" onClick={Salvar}>
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="row">
        <h1 className="ms-4">Lançamento de Despesa</h1>

        <p className="ms-4">
          Rotina para lançar as despesas com os fornecedores da empresa.
        </p>
        <hr />
      </div>

      <div className="row ps-2 pe-2">
        <div className="col-sm-5">
          <label className="form-label form-check-label" htmlFor="busca">
            Busque aqui
          </label>
          <input
            type="text"
            placeholder="Buscar por: Código, Código Fornecedor ou Nome"
            name="busca"
            id="busca"
            className="form-control me-3"
            value={abusca}
            onChange={(e) => setabusca(e.target.value)}
          />
        </div>

        <div className="col-sm-1">
          <label htmlFor="tipo" className="form-label">
            Filtrar por
          </label>
          <br />
          <div className="form-radio form-radio-inline">
            <input
              className="form-radio-input"
              id="lanc"
              type="radio"
              name="tipo"
              value="L"
              onChange={(e) => settipo(e.target.value)}
              checked={tipo === "L"}
            />
            <label htmlFor="lanc" className="form-radio-label">
              Lanç.
            </label>
          </div>

          <div className="form-radio form-radio-inline">
            <input
              className="form-radio-input"
              id="venc"
              type="radio"
              name="tipo"
              value="V"
              onChange={(e) => settipo(e.target.value)}
              checked={tipo === "V"}
            />
            <label htmlFor="venc" className="form-radio-label">
              Venc.
            </label>
          </div>
        </div>

        <div className="col-sm-2">
          <label htmlFor="periodo" className="form-label">
            {tipo === "L" ? "Lançamento de..." : "Vencimento de..."}
          </label>
          <br />
          <input
            type="date"
            id="periodo"
            className="form-control"
            placeholder="Data Inicio"
            value={dt1}
            onChange={(e) => setdt1(e.target.value)}
          />
        </div>

        <div className="col-sm-2">
          <label htmlFor="periodo" className="form-label">
            Para...
          </label>
          <br />
          <input
            type="date"
            id="periodo2"
            className="form-control"
            placeholder="dtnascimento"
            value={dt2}
            onChange={(e) => setdt2(e.target.value)}
          />
        </div>

        <div className="col-sm-2 d-flex justify-content-center">
          <button className="btn btn-success btnnovo" onClick={(e) => Novo()}>
            Novo
          </button>
        </div>
      </div>

      <div className="row mt-3">
        <hr />
      </div>

      <table className="table table-hover fonte">
        <thead>
          <tr>
            <th className="codigo">Código</th>
            <th className="parcela">Parcela</th>
            <th className="lancamento">Lançamento</th>
            <th className="vencimento">Vencimento</th>
            <th className="cliente">Funcionário</th>
            <th className="valor">Valor</th>
            <th className="historico">Histórico</th>
          </tr>
        </thead>
        <tbody>
          {listadespesa.map(function (item) {
            return (
              <tr key={item.codcontaspagar}>
                <th>{item.codcontaspagar}</th>
                <th>{item.parcela}</th>
                <th>{FormataDataHora(item.dtlancamento)}</th>
                <th>{FormataData(item.dtvencimento)}</th>
                <th>{item.nome}</th>
                <th>{item.vlliquido}</th>
                <th>{item.historico}</th>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <th colSpan={5}>Quantidade de Registros: {listadespesa.length}</th>
          </tr>
        </tfoot>
      </table>
    </>
  );
}

export default LancDespesa;
